import {
  formatPenaltyAdjustment,
  penaltyMillisecondsToWholeSeconds,
} from '@/lib/session-result-timing'
import { cn } from '@/lib/utils'

function PenaltyAdjustmentBadge({ penaltyTime }) {
  const label = formatPenaltyAdjustment(penaltyTime)

  if (!label) return null

  return (
    <span
      className={cn(
        'whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] leading-none font-semibold tabular-nums',
        {
          'bg-error-500/15 text-error-300':
            penaltyMillisecondsToWholeSeconds(penaltyTime) > 0,
          'bg-success-500/15 text-success-300':
            penaltyMillisecondsToWholeSeconds(penaltyTime) < 0,
        },
      )}
    >
      {label}
    </span>
  )
}

export default function StandingsDriverLapCell({
  position,
  status,
  time,
  type,
  displayValue,
  penaltyTime,
}) {
  const parseMsToTime = (ms) => {
    if (type === 'LAP') {
      return parseInt(ms)
    }

    const totalSeconds = Math.floor(ms / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    const milliseconds = ms % 1000

    const time = {
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
      milliseconds: String(milliseconds).padStart(3, '0'),
    }

    return `${time.minutes}:${time.seconds}.${time.milliseconds}`
  }

  switch (status) {
    case 'dnf':
    case 'dns':
    case 'dsq':
      return (
        <div
          className={cn(
            'flex h-full w-[100px] flex-col items-center justify-center gap-1 rounded-sm border py-2 text-center font-medium md:h-[46px] md:w-full md:px-4',
            {
              'border-warning-500': status === 'dnf',
              'border-error-500': status === 'dns' || status === 'dsq',
            },
          )}
        >
          <span>{status.toUpperCase()}</span>
          <PenaltyAdjustmentBadge penaltyTime={penaltyTime} />
        </div>
      )

    default:
      const classes =
        position === 1
          ? 'bg-[#5811CB]'
          : 'bg-neutral-blue-800 md:bg-neutral-blue-900 border-none md:border border-neutral-blue-800 md:border-neutral-blue-900'
      return (
        <div
          className={cn(
            'flex h-full w-[100px] flex-col items-center justify-center gap-1 rounded-sm py-2 text-center md:h-[46px] md:w-full md:px-4',
            classes,
          )}
        >
          <span className="font-semibold tabular-nums">
            {displayValue ?? (
              <>
                {['GAP', 'LAP'].includes(type) ? '+' : ''}
                {type === 'LAP'
                  ? `${time} lap${time > 1 ? 's' : ''}`
                  : parseMsToTime(time)}
              </>
            )}
          </span>
          <PenaltyAdjustmentBadge penaltyTime={penaltyTime} />
        </div>
      )
  }
}
